/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const createc_planetario_luminaria_zona3 = (block) => {
  const estado = block.getFieldValue('STAT');
  return `Planetario_LuminariaCalle(${estado});\n`;
};

export const createc_planetario_luminaria_cupula = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  generator.loop_footer_.createc_planetario_luminaria_cupula = 'Planetario_checkCupula();\n';
  return `Planetario_efectoCupula(${estado});\n`;
};

export const createc_planetario_luminaria_cupula_off = (block, generator) => {
  generator.loop_footer_.createc_planetario_luminaria_cupula = 'Planetario_checkCupula();\n';
  return 'Planetario_apagarLucesCupula();\n';
};

export const createc_planetario_reflector = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.createc_planetario_reflector = 'Planetario_checkReflectores();\n';
  return `Planetario_prenderLucesReflectores(${color});\n`;
};

export const createc_planetario_reflector_off = (block, generator) => {
  generator.loop_footer_.createc_planetario_reflector = 'Planetario_checkReflectores();\n';
  return 'Planetario_apagarLucesReflectores();\n';
};

export const createc_planetario_screen = (block, generator) => {
  const message = block.getFieldValue('STAT');
  generator.loop_footer_.createc_planetario_screen = 'Planetario_checkpantalla();\n';
  return `Planetario_EscribirMensaje(${message});\n`;
};

export const createc_planetario_telescope_degrees = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  generator.loop_footer_.createc_planetario_telescope = 'Planetario_checkTelescopio();\n';
  return `Planetario_Lente_Mover(${angle});\n`;
};

export const createc_planetario_telescope_direction = (block, generator) => {
  const target = block.getFieldValue('STAT');
  generator.loop_footer_.createc_planetario_telescope = 'Planetario_checkTelescopio();\n';
  return `Planetario_Base_Mover(${target});\n`;
};

export const slider_angle_telescopio = (block, generator) => {
  const code = block.getFieldValue('angulo');
  return [code, generator.ORDER_ATOMIC];
};
